import {
  Alert,
  Box,
  Breadcrumbs,
  Button,
  Chip,
  Divider,
  FormControl,
  FormLabel,
  Link,
  Radio,
  RadioGroup,
} from "@mui/joy";
import { useEffect, useState } from "react";
import { Cargando } from "../utils/Cargando";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Grid2,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { centrado } from "../utils/Estilos";
import { theme2 } from "../theme";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import CheckIcon from "@mui/icons-material/Check";
import agotado from "./../assets/image/agotados.png";
import {
  PayPalOneTimePaymentButton,
  PayPalProvider,
} from "@paypal/react-paypal-js/sdk-v6";

import { Helmet } from "react-helmet";
import { useRef } from "react";

export function generarString() {
  let result = "";
  const abc = (
    " 0 1 2 3 4 5 6 7 8 9" +
    " A B C D E F G H I J K L M N O P Q R S T U V W X Y Z"
  ).split(" ");
  for (let i = 0; i <= 8; i++) {
    let valor = Math.random(); //NOSONAR
    const random = Math.floor(valor * abc.length);
    result += abc[random];
  }
  return result;
}

function formatearTexto(text) {
  return text
    .split(" ") // Divide el texto en palabras
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Convierte la primera letra a mayúscula
    .join(" "); // Vuelve a unir las palabras
}

export const Carrito = () => {
  const dispatch = useDispatch();
  const carrito = useSelector((state) => state.carrito?.carro);
  const navigate = useNavigate();

  // const [paypal, setPaypal] = useState({});

  // const [paypone, setPayphone] = useState({});

  const [timeLeft, setTimeLeft] = useState(0); // En segundos
  const timerRef = useRef(null);

  // Efecto que ejecuta el temporizador
  // useEffect(() => {
  //   if (timeLeft > 0) {
  //     timerRef.current = setInterval(() => {
  //       setTimeLeft((prevTime) => prevTime - 1);
  //     }, 1000);
  //   }

  //   if (timeLeft === 0 && paypal?.id && paypal?.cambiando !== "SI") {
  //     setPaypal({ ...paypal, cambiando: "SI" });
  //     cambiarEstado("CANCELADO", paypal?.id);
  //   }

  //   return () => clearInterval(timerRef.current); // Limpia el temporizador si el componente se desmonta o reinicia
  // }, [timeLeft]);

  const startTimer = () => {
    clearInterval(timerRef.current); // Limpia temporizadores previos si existen
    // setTimeLeft(600); // 10 minutos = 600 segundos
    setTimeLeft(610);
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const regex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const [objeto, setObjeto] = useState({});
  const [load, setLoad] = useState(false);

  const [error, setError] = useState(null);
  const [productos, setProductos] = useState(null);

  function validarCorreoElectronico(correoElectronico) {
    return !!regex.test(correoElectronico.toLowerCase());
  }
  useEffect(() => {
    setLoad(false);
    setError(null);
    cargar();
    // setPaypal({});
  }, []);

  useEffect(() => {
    if (!(objeto?.ids?.length >= 0) && !load) {
      setObjeto({
        ...objeto,
        carrito: carrito,
      });
    }
    // setPaypal({});
  }, [carrito]);

  function cargar() {
    setObjeto({
      carrito: carrito,
    });
    const myHeaders = new Headers();
    myHeaders.append("X-Api-Key", process.env.REACT_APP_TOKEN);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `https://portal.publimed.net/api/v1/CProducto?searchParams={"where": [{ "type": "equals", "attribute": "estado","value":"ACTIVO"},
      { "type": "equals", "attribute": "tipo","value":"CON STOCK"}],
      "select": ["posicion1Id","posicion2Id","posicion3Id","posicion4Id","posicion5Id",
      "especialidadsIds","id","name","deleted","description","precio","tipo","tipo1","tipo2","precio1","precio2","especialidades","descuento","precioSinDescuento","categorias","fotoId","fotoName"]}`,
      requestOptions,
    )
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);
        setProductos([
          ...res.list.map((val) => {
            let precios = [];
            if (val?.tipo === "CON STOCK" && val?.posicion1Id === null) {
              precios.push(parseFloat(val?.precio1));
            }
            if (
              val?.tipo === "CON STOCK" &&
              [
                val?.posicion2Id,
                val?.posicion3Id,
                val?.posicion4Id,
                val?.posicion5Id,
              ].filter((val) => val === null).length > 0
            ) {
              precios.push(parseFloat(val?.precio2));
            }

            if (!isNaN(val?.precio) && val?.tipo === "SIN STOCK") {
              precios.push(parseFloat(val?.precio));
            }
            return {
              ...val,
              minimo: Math.min(...precios),
              especialidades:
                val?.especialidadsIds?.length > 0
                  ? Object.values(val?.especialidadsNames)
                  : val?.especialidades,
              maximo: Math.max(...precios),
            };
          }),
        ]);
      })
      .catch((error) => {
        console.error(error);
        setProductos([]);
      });
  }

  function getTotal() {
    return objeto?.carrito
      ? objeto?.carrito
          ?.reduce(
            (accumulator, currentValue) =>
              accumulator +
              parseFloat(parseFloat(currentValue?.total ?? 0).toFixed(2)),
            0,
          )
          .toFixed(2)
      : "0.00";
  }

  function getTotalCompra() {
    return objeto?.ids
      ? objeto?.ids
          ?.reduce(
            (accumulator, currentValue) =>
              accumulator +
              parseFloat(parseFloat(currentValue?.subtotal ?? 0).toFixed(2)),
            0,
          )
          .toFixed(2)
      : "0.00";
  }

  function getDescuento() {
    if (!objeto?.cuponId) {
      return "0.00";
    }

    let valor = parseFloat(objeto?.cuponId?.valor ?? 0);

    if (objeto?.cuponId?.tipo === "VALOR") {
      return valor.toFixed(2);
    }

    let total = parseFloat(getTotal());
    let porcentaje = valor / 100;

    return (total * porcentaje).toFixed(2);
  }

  function validarCupon() {
    setLoad(true);
    const myHeaders = new Headers();
    myHeaders.append("X-Api-Key", process.env.REACT_APP_TOKEN);
    myHeaders.append("Content-Type", "application/json");
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(
      `https://portal.publimed.net/api/v1/CCupon?searchParams={"where": [{ "type": "equals", "attribute": "name","value":"${objeto?.cupon}"},{ "type": "equals", "attribute": "estado","value":"NUEVO"}]}`,
      requestOptions,
    )
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);

        let cup = res?.list[0];

        if (cup) {
          if (cup?.externo === "SI") {
            if (objeto?.carrito?.length > 1) {
              Swal.fire({
                icon: "error",
                text: "Este cupón es válido solo para un ítem Libro Digital/Artículo Médico",
              });
              setObjeto({
                ...objeto,
                cupon: null,
              });
            } else if (
              objeto?.carrito?.length === 1 &&
              objeto?.carrito[0]?.producto?.tipo !== "CON STOCK"
            ) {
              Swal.fire({
                icon: "error",
                text: "Este cupón es válido solo para productos: Libro Digital/Artículo Médico",
              });
              setObjeto({
                ...objeto,
                cupon: null,
              });
            } else {
              setObjeto({
                ...objeto,
                cuponId: cup,
              });
            }
          } else {
            setObjeto({
              ...objeto,
              cuponId: cup,
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            text: "El cupón no esta disponible",
          });
          setObjeto({
            ...objeto,
            cupon: null,
          });
        }
        setLoad(false);
      })
      .catch((error) => {
        console.error(error);
        setObjeto({
          ...objeto,
          cupon: null,
        });
        setLoad(false);
        Swal.fire({
          icon: "error",
          text: "No se ha podido consultar el cupón",
        });
      });
  }

  function cambiarCantidad(index) {
    let listaN = objeto?.carrito.concat([]);
    listaN = listaN.filter((val, ind) => ind !== index);

    dispatch({
      type: "CARRO_SUCCESS",
      payload: {
        carro: listaN,
      },
    });
    localStorage.setItem("carritoPublimed", JSON.stringify(listaN));
  }

  async function crearCompra() {
    if (!objeto?.pago) {
      Swal.fire({
        icon: "warning",
        text: "Escoja un método de Pago",
      });
      return;
    }
    setLoad(true);
    const myHeaders = new Headers();
    myHeaders.append("X-Api-Key", process.env.REACT_APP_TOKEN);
    myHeaders.append("Content-Type", "application/json");
    let contenido = {
      name: objeto?.correo?.trim() + " " + new Date().toISOString(),
      nombre: formatearTexto(objeto?.nombre?.trim() ?? ""),
      apellido: formatearTexto(objeto?.apellido?.trim() ?? ""),
      description: objeto?.ids
        ?.map((val) => {
          return val.id;
        })
        ?.toString(),
      cedula: objeto?.cedula?.trim(),
      celular: objeto?.celular?.trim(),
      correo: objeto?.correo?.trim(),
      profesion: objeto?.profesion?.trim(),
      ciudad: objeto?.ciudad?.trim(),
      universidad: objeto?.universidad?.trim(),
      pais: objeto?.pais?.trim(),
      lugar: objeto?.lugar?.trim(),
      filiacion: objeto?.filiacion?.trim(),
      orcid: objeto?.orcid?.trim(),
      nacimiento: objeto?.nacimiento ?? null,
      clienteId: objeto?.usuario ?? null,
      cuponId: objeto?.cuponId?.id ?? null,

      carritosIds:
        objeto?.ids?.map((val) => {
          return val.id;
        }) ?? [],

      total: objeto?.ids
        ?.reduce(
          (accumulator, currentValue) =>
            accumulator +
            parseFloat(parseFloat(currentValue?.subtotal ?? 0).toFixed(2)),
          0,
        )
        .toFixed(2),
    };

    if (objeto?.pago === "transferencia") {
      contenido = {
        ...contenido,
        estado: "EN REVISION",
      };
    }

    const requestOptions = {
      method: "POST",
      body: JSON.stringify(contenido),
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch("https://publimed.net/API/verificar.php", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);
        if (res?.id) {
          const requestOptions2 = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
          };
          fetch(
            "https://portal.publimed.net/api/v1/CCompra/" + res?.id,
            requestOptions2,
          )
            .then((response) => response.text())
            .then((result) => {
              let res2 = JSON.parse(result);
              if (res2?.estado === "EN REVISION") {
                Swal.fire({
                  icon: "success",
                  willClose: () => {
                    setObjeto({});
                    localStorage.setItem("carritoPublimed", JSON.stringify([]));
                    localStorage.setItem("carritoPro", JSON.stringify([]));
                    dispatch({
                      type: "CARRO_SUCCESS",
                      payload: {
                        carro: [],
                      },
                    });
                    navigate("/");
                  },
                  html:
                    "Se le enviará un correo con los datos bancarios para el pago correspondiente e indique el código de la compra: <strong>" +
                    res2?.id +
                    "</strong> <br/>Muchas gracias por preferirnos",
                });
                setLoad(false);
              } else if (res2?.estado === "APROBADO") {
                navigate("/resultado/" + res2?.id);
              } else {
                // setPaypal({
                //   id: res2?.id,
                //   total: parseFloat(res2?.total).toFixed(2),
                // });
                // startTimer();
                // setLoad(false);
                comprar(
                  res2?.id,
                  parseFloat(res2?.total).toFixed(2),
                  // parseFloat(res2?.total).toFixed(2).replace(".", ""),
                );
              }
            })
            .catch((error) => {
              console.error(error);
              setLoad(false);
              Swal.fire({
                icon: "error",
                text: "No se ha podido registrar la compra, revise el carrito e intente nuevamente",
              });
              setObjeto({
                carrito: carrito,
              });
            });
        } else {
          setLoad(false);
          Swal.fire({
            icon: "error",
            text: "No se ha podido registrar la compra, revise el carrito e intente nuevamente",
          });
          setObjeto({
            carrito: carrito,
          });
        }
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({
          icon: "error",
          text: "No se ha podido registrar la compra, revise el carrito e intente nuevamente",
        });
        setObjeto({
          carrito: carrito,
        });
        setLoad(false);
      });
  }

  function comprar(id, total) {
    const myHeaders = new Headers();
    myHeaders.append("X-Api-Key", process.env.REACT_APP_DLOCALPRUEBAS);
    let body = {
      currency: "USD",
      country: "EC",
      payment_type: "CREDIT_CARD,DEBIT_CARD,BANK_TRANSFER",
      description: "Pago Publimed",
      amount: total,
      order_id: id,
      notification_url: "https://publimed.net/API/dlocalgo.php",
      back_url: "https://publicacionesmedicas.publimed.net/response/" + id,
      expiration_type: "MINUTES",
      expiration_value: 10,
    };

    fetch("https://publimed.net/API/compraLocal.php", {
      headers: myHeaders,
      method: "POST",
      body: JSON.stringify(body),
    })
      .then((res) => res.text())
      .then((res) => {
        let res2 = JSON.parse(res);
        // console.log(res2);
        if (res2?.redirect_url) {
          window.location.href = res2?.redirect_url;
          // console.log(res2?.redirect_url);
        }
      })
      .catch((error) => {
        setLoad(false);
        console.error(error);
        Swal.fire({
          icon: "error",
          text: error,
        });
      });

    // let body = JSON.stringify({
    //   amount: total,
    //   amountWithoutTax: total,
    //   clientTransactionID: id,
    //   responseUrl: "https://publimed.net/API/respuesta2.php",
    //   cancellationUrl: "https://publimed.net/API/respuesta2.php",
    // });
    // let headers2 = new Headers();
    // headers2.append(
    //   "Authorization",
    //   "Bearer " + process.env.REACT_APP_PAYPHONE,
    // );
    // headers2.append("Content-Type", "application/json");
    // let options = {
    //   method: "POST",
    //   headers: headers2,
    //   body: body,
    // };
    // fetch("https://pay.payphonetodoesposible.com/api/button/Prepare", options)
    //   .then((res) => res.text())
    //   .then((res) => {
    //     //econsole.log(JSON.parse(res));
    //     window.location.href = JSON.parse(res).payWithCard;
    //   })
    //   .catch((error) => {
    //     setLoad(false);
    //     console.error(error);
    //     Swal.fire({
    //       icon: "error",
    //       text: error,
    //     });
    //   });
  }

  async function crearUsuario() {
    setLoad(true);

    if (objeto?.cupon?.externo === "SI") {
      if (objeto?.carrito?.length > 1) {
        Swal.fire({
          icon: "error",
          text: "Este cupón es válido solo para un ítem Libro Digital/Artículo Médico",
        });
        setObjeto({
          ...objeto,
          cupon: null,
        });
        setLoad(false);
        return;
      } else if (
        objeto?.carrito?.length === 1 &&
        objeto?.carrito[0]?.producto?.tipo !== "CON STOCK"
      ) {
        Swal.fire({
          icon: "error",
          text: "Este cupón es válido solo para productos: Libro Digital/Artículo Médico",
        });
        setObjeto({
          ...objeto,
          cupon: null,
        });
        setLoad(false);
        return;
      }
    }

    let informacion = await getUsuario(objeto?.correo?.trim());
    let usuario = informacion?.id;
    if (!usuario) {
      const myHeaders = new Headers();
      myHeaders.append("X-Api-Key", process.env.REACT_APP_TOKEN);
      myHeaders.append("Content-Type", "application/json");
      let contenido = {
        name: objeto?.correo?.trim(),
        password: generarString(),
      };

      const requestOptions = {
        method: "POST",
        body: JSON.stringify(contenido),
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch("https://portal.publimed.net/api/v1/CCliente", requestOptions)
        .then((response) => response.text())
        .then((result) => {
          let res = JSON.parse(result);
          //econsole.log("usuario creado");
          usuario = res?.id ?? null;
        })
        .catch((error) => {
          console.error(error);
          usuario = null;
        });
    }
    if (usuario) {
      crearCarrito(usuario, informacion);
    } else {
      setLoad(false);
      Swal.fire({
        icon: "error",
        text: "No se ha creado el usuario, intente más tarde",
      });
      console.error("No usuario");
    }
  }

  function cambiarEstado(estado, id, payload = "") {
    setLoad(true);
    const myHeaders = new Headers();
    myHeaders.append("X-Api-Key", process.env.REACT_APP_TOKEN);
    myHeaders.append("Content-Type", "application/json");
    const requestOptions = {
      method: "POST",
      body: JSON.stringify({
        estado: estado,
        id: id,
        description: JSON.stringify(payload), //no mover es respuestaBoton
      }),
      headers: myHeaders,
      redirect: "follow",
    };

    fetch("https://publimed.net/API/paypal.php", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);
        navigate("/resultado/" + res?.id);
      })
      .catch((error) => {
        setLoad(false);
        Swal.fire({
          icon: "error",
          text: "No se ha podido registrar la compra, revise el carrito e intente nuevamente",
        });
        setObjeto({
          carrito: carrito,
        });
        // setTimeLeft(0);
        // setPaypal({});
        setError(null);
        console.error(error);
      });
  }

  async function crearCarrito(usuario, informacion) {
    const myHeaders = new Headers();
    myHeaders.append("X-Api-Key", process.env.REACT_APP_TOKEN);
    myHeaders.append("Content-Type", "application/json");

    let idsCarrito = [];

    for (const el of objeto.carrito) {
      let contenido = {
        clienteId: usuario,
        name: el.producto.name,
        productoId: el.producto.id,
        eleccion: el?.eleccion,

        parentType: "CProducto",
        parentId: el.producto.id,
      };
      if (el?.espe?.length > 0) {
        contenido = {
          ...contenido,
          espe: el?.espe.join(","),
          productoId: null,
          parentType: "CPlanArticulo",
        };
      } else if (el?.eleccion === undefined) {
        contenido = {
          ...contenido,
          productoId: null,
          parentType: "CCurso",
        };
      }

      const requestOptions = {
        method: "POST",
        body: JSON.stringify(contenido),
        headers: myHeaders,
        redirect: "follow",
      };

      let info = "";

      let respuesta = await fetch(
        "https://portal.publimed.net/api/v1/CCarrito",
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          let res = JSON.parse(result);
          if (!res?.id) {
            console.error(res);
            Swal.fire({
              icon: "error",
              text:
                "Error: " +
                JSON.stringify(res)
                  .replaceAll("{", "")
                  .replaceAll("}", "")
                  .replaceAll('"message":', ""),
            });
            info = JSON.stringify(res);
            return null;
          } else {
            idsCarrito.push(res?.id);
            return res.id;
          }
        })
        .catch((error) => {
          console.error(error);
          Swal.fire({
            icon: "error",
            text: "Error: La autoría seleccionada ya no esta disponible",
          });
          return null;
        });

      if (!respuesta) {
        setLoad(false);
        let tipo = !isNaN(el?.eleccion)
          ? " Tipo: " + [el?.producto?.tipo1, el?.producto?.tipo2][el?.eleccion]
          : "";
        if (!info.includes("elecc")) {
          setError({
            tipo: tipo,
            producto: el.producto,
          });
        }
        let listaN =
          objeto?.carrito?.filter(
            (val) =>
              !(
                val.producto?.id === el.producto?.id &&
                val.eleccion === el.eleccion
              ),
          ) ?? [];
        dispatch({
          type: "CARRO_SUCCESS",
          payload: {
            carro: listaN,
          },
        });
        setObjeto({
          ...objeto,
          carrito: listaN,
        });
        localStorage.setItem("carritoPublimed", JSON.stringify(listaN));
        localStorage.setItem("carritoPro", JSON.stringify([]));
        return;
      }
    }
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    let url =
      `https://portal.publimed.net/api/v1/CCarrito?searchParams={"where": [{ "type": "in", "attribute": "id","value":` +
      ` [${
        idsCarrito
          ?.map((val) => {
            return '"' + val + '"';
          })
          ?.toString() ?? ""
      }]}]}`;
    let nuevosCarros = await fetch(url, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);
        return res?.list ?? null;
      })
      .catch((error) => {
        console.error(error);
        return null;
      });

    if (nuevosCarros === null) {
      Swal.fire({
        icon: "error",
        text: "Ha ocurrido un error, revise el carrito e intente nuevamente",
      });
    } else {
      localStorage.setItem("carritoPro", JSON.stringify(nuevosCarros));
      //econsole.log("ids ", nuevosCarros);
      setObjeto({
        ...informacion,
        ...objeto,
        ids: nuevosCarros,
        usuario: usuario,
      });
    }
    setLoad(false);
  }

  async function getUsuario(usuario) {
    const myHeaders = new Headers();
    myHeaders.append("X-Api-Key", process.env.REACT_APP_TOKEN);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return await fetch(
      `https://portal.publimed.net/api/v1/CCliente?searchParams={"where": [{ "type": "equals", "attribute": "name","value": "${usuario}"}]}`,
      requestOptions,
    )
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);
        return res?.list && res?.list[0] ? res?.list[0] : null;
      })
      .catch((error) => {
        console.error(error);
        return null;
      });
  }

  return (
    <Box py={3} sx={{ width: "100%", ...centrado, flexWrap: "wrap" }}>
      <Helmet>
        <title>{"Publimed Store - Carrito"}</title>
      </Helmet>
      <Cargando open={!carrito} />
      <Cargando open={load} />
      {carrito && (
        <>
          <Box sx={{ width: "90%" }}>
            <Breadcrumbs sx={{ fontSize: "24px" }}>
              <Link
                underline="always"
                color="primary"
                onClick={() => navigate("/publicaciones")}
              >
                <strong>Publicaciones médicas</strong>
              </Link>
              <Typography sx={{ color: "text.primary", fontSize: "24px" }}>
                <strong>Carrito</strong>
              </Typography>
            </Breadcrumbs>
          </Box>
          <Box sx={{ width: "90%" }}>
            <Grid2 container sx={{ width: "100%", ...centrado }}>
              <Grid2
                size={{ xs: 12, md: 8 }}
                sx={{ padding: "20px", minWidth: 400, overflowX: "auto" }}
              >
                {objeto?.carrito?.length > 0 ? (
                  <TableContainer sx={{ maxHeight: 400 }}>
                    <Table
                      stickyHeader
                      sx={{
                        borderCollapse: "separate",
                        borderSpacing: "0px 5px",
                        "& .MuiTableCell-stickyHeader": {
                          fontWeight: "bold",
                          fontSize: "18px",
                          color: "white",
                          backgroundColor: theme2.palette.primary.main,
                        },
                        "& .MuiTableCell-body ": {
                          backgroundColor: "white",
                        },
                      }}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ minWidth: 120 }}>Producto</TableCell>
                          <TableCell align="center" sx={{ minWidth: 120 }}>
                            Total
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{ minWidth: 90 }}
                          ></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {objeto?.carrito?.map((val, index) => (
                          <TableRow key={index}>
                            <TableCell>
                              <strong>{val?.producto?.name} </strong>
                              <Typography>
                                {!isNaN(val?.eleccion)
                                  ? "TIPO: " +
                                    [
                                      val?.producto?.tipo1,
                                      val?.producto?.tipo2,
                                    ][val?.eleccion]
                                  : ""}
                                {val?.espe ? val?.espe.join(",") : ""}
                              </Typography>
                              {val?.producto?.solicitar?.map((val2) => (
                                <Typography key={val2}>
                                  {val[val2.toLowerCase().split(" ")[0]]
                                    ? val2 +
                                      ": " +
                                      val[val2.toLowerCase().split(" ")[0]]
                                    : ""}
                                </Typography>
                              ))}
                            </TableCell>
                            <TableCell align="center" sx={{ minWidth: 120 }}>
                              {" "}
                              {val?.producto?.descuento === "SI" ? (
                                <>
                                  <Typography
                                    color="gray"
                                    sx={{
                                      textDecoration: "line-through",
                                      fontSize: "0.875rem",
                                    }}
                                  >
                                    {"$ " +
                                      parseFloat(
                                        val?.producto?.preciodescuento,
                                      ).toFixed(2)}
                                  </Typography>
                                </>
                              ) : (
                                ""
                              )}
                              $ {val?.total}
                            </TableCell>
                            <TableCell align="right" sx={{ minWidth: 90 }}>
                              <Button
                                variant="outlined"
                                color="danger"
                                onClick={() => {
                                  cambiarCantidad(index);
                                }}
                              >
                                Eliminar
                              </Button>
                              {/* <IconButton
                                onClick={() => {
                                  cambiarCantidad(index);
                                }}
                              >
                                <DeleteIcon color="error" />
                              </IconButton> */}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <>
                    <Typography variant="h6" fontWeight={"bold"}>
                      Carrito
                    </Typography>
                    <Alert color="neutral">No hay productos agregados</Alert>
                  </>
                )}
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }} sx={{ padding: "20px" }}>
                <Paper
                  elevation={6}
                  sx={{
                    padding: "30px",
                    ...centrado,
                  }}
                >
                  <Box sx={{ width: "100%" }}>
                    <Typography pt={1}>
                      <strong>Correo electrónico: *</strong>
                    </Typography>
                    <TextField
                      fullWidth
                      id="email"
                      name="email"
                      autoComplete="email"
                      value={objeto?.correo ?? ""}
                      onChange={(e) =>
                        setObjeto({ ...objeto, correo: e.target.value })
                      }
                      size="small"
                    />
                    {objeto?.correo &&
                      !validarCorreoElectronico(objeto?.correo) && (
                        <Alert color="warning">
                          Ingrese un correo electrónico válido
                        </Alert>
                      )}

                    <Typography pt={3} sx={{ fontSize: "14px" }}>
                      <strong>Cupón: (Si tiene uno)</strong>
                    </Typography>
                    <Stack direction={"row"} gap={1}>
                      <TextField
                        fullWidth
                        autoComplete="off"
                        disabled={objeto?.cuponId}
                        value={objeto?.cupon ?? ""}
                        onChange={(e) =>
                          setObjeto({
                            ...objeto,
                            cupon: e.target.value
                              ? e.target.value?.trim()
                              : e.target.value,
                          })
                        }
                        size="small"
                      />
                      <Button
                        variant="solid"
                        color="success"
                        disabled={
                          !(objeto?.cupon?.length > 0) || objeto?.cuponId
                        }
                        onClick={() => validarCupon()}
                      >
                        <CheckIcon />
                      </Button>
                    </Stack>
                    <Typography
                      align="right"
                      py={1}
                      sx={{ color: "text.primary", fontSize: "20px" }}
                    >
                      <strong>Subtotal: </strong>${getTotal()}
                    </Typography>
                    <Typography
                      align="right"
                      py={1}
                      sx={{ color: "text.primary", fontSize: "20px" }}
                    >
                      <strong>Descuento: </strong>${getDescuento()}
                    </Typography>
                    <Divider />
                    <Typography
                      py={1}
                      align="right"
                      sx={{ color: "text.primary", fontSize: "24px" }}
                    >
                      <strong>Total: </strong>$
                      {(
                        parseFloat(getTotal()) - parseFloat(getDescuento())
                      ).toFixed(2)}
                    </Typography>
                    <Box textAlign={"right"}>
                      <Button
                        size="lg"
                        onClick={() => crearUsuario()}
                        disabled={
                          (objeto?.cupon?.length > 0 && !objeto?.cuponId) ||
                          !validarCorreoElectronico(objeto?.correo ?? "") ||
                          !(objeto?.carrito?.length > 0)
                        }
                      >
                        Continuar con la compra
                      </Button>
                    </Box>
                  </Box>
                </Paper>
              </Grid2>
            </Grid2>
          </Box>

          <Dialog
            sx={{ zIndex: 10000 }}
            open={objeto?.ids?.length > 0}
            maxWidth="md"
            fullWidth
            onClose={() => {
              setObjeto({
                carrito: carrito,
              });
            }}
          >
            <DialogContent>
              <Box sx={{ padding: "20px" }}>
                <Typography variant="h5" sx={{ textAlign: "center" }}>
                  <strong>
                    Datos personales para la Publicación / Trabajo
                  </strong>
                </Typography>
                <br />
                <Divider/>

                <br />
                <Grid2 container spacing={2}>
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <Typography>
                      <strong>Nombres : *</strong>
                    </Typography>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      value={objeto?.nombre ?? ""}
                      onChange={(e) =>
                        setObjeto({ ...objeto, nombre: e.target.value })
                      }
                      size="small"
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <Typography>
                      <strong>Apellidos : *</strong>
                    </Typography>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      value={objeto?.apellido ?? ""}
                      onChange={(e) =>
                        setObjeto({ ...objeto, apellido: e.target.value })
                      }
                      size="small"
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <Typography>
                      <strong>Correo electrónico: *</strong>
                    </Typography>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      disabled
                      value={objeto?.correo ?? ""}
                      size="small"
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <Typography>
                      <strong>DNI/Cédula: *</strong>
                    </Typography>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      value={objeto?.cedula ?? ""}
                      onChange={(e) => {
                        const regex = new RegExp("^([0-9]{0,15})$");
                        if (regex.test(e.target.value)) {
                          setObjeto({ ...objeto, cedula: e.target.value });
                        }
                      }}
                      size="small"
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <Typography>
                      <strong>Celular: *</strong>
                    </Typography>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      value={objeto?.celular ?? ""}
                      onChange={(e) => {
                        const regex = new RegExp("^([0-9]{0,15})$");
                        if (regex.test(e.target.value)) {
                          setObjeto({ ...objeto, celular: e.target.value });
                        }
                      }}
                      size="small"
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <Typography>
                      <strong>Ciudad: *</strong>
                    </Typography>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      value={objeto?.ciudad ?? ""}
                      onChange={(e) =>
                        setObjeto({ ...objeto, ciudad: e.target.value })
                      }
                      size="small"
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <Typography>
                      <strong>País: *</strong>
                    </Typography>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      value={objeto?.pais ?? ""}
                      onChange={(e) =>
                        setObjeto({ ...objeto, pais: e.target.value })
                      }
                      size="small"
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <Typography>
                      <strong>Profesión / Carrera: *</strong>
                    </Typography>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      value={objeto?.profesion ?? ""}
                      onChange={(e) =>
                        setObjeto({ ...objeto, profesion: e.target.value })
                      }
                      size="small"
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <Typography>
                      <strong>Fecha de Nacimiento: *</strong>
                    </Typography>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      type="date"
                      value={objeto?.nacimiento ?? ""}
                      onChange={(e) =>
                        setObjeto({ ...objeto, nacimiento: e.target.value })
                      }
                      size="small"
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 6 }}></Grid2>
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <Typography>
                      <strong>Datos de filiación: </strong>
                    </Typography>
                    <Typography fontSize={"12px"}>(Opcional)</Typography>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      value={objeto?.filiacion ?? ""}
                      onChange={(e) =>
                        setObjeto({ ...objeto, filiacion: e.target.value })
                      }
                      size="small"
                    />
                  </Grid2>
                  {objeto?.ids?.filter((val) => !isNaN(val?.eleccion)).length >
                    0 && (
                    <>
                      <Grid2 size={{ xs: 12, md: 6 }}>
                        <Typography>
                          <strong>Lugar de Trabajo: *</strong>
                        </Typography>
                        <Typography fontSize={"12px"}>
                          Si no tiene colocar la palabra "Privado"
                        </Typography>
                        <TextField
                          autoComplete="off"
                          fullWidth
                          value={objeto?.lugar ?? ""}
                          onChange={(e) =>
                            setObjeto({ ...objeto, lugar: e.target.value })
                          }
                          size="small"
                        />
                      </Grid2>
                      <Grid2 size={{ xs: 12, md: 6 }}>
                        <Typography>
                          <strong>Universidad y año de graduación: *</strong>
                        </Typography>
                        <Typography fontSize={"12px"}>
                          Si es estudiante solo colocar el nombre de la
                          Universidad
                        </Typography>
                        <TextField
                          autoComplete="off"
                          fullWidth
                          value={objeto?.universidad ?? ""}
                          onChange={(e) =>
                            setObjeto({
                              ...objeto,
                              universidad: e.target.value,
                            })
                          }
                          size="small"
                        />
                      </Grid2>
                      <Grid2 size={{ xs: 12, md: 6 }}>
                        <Typography>
                          <strong>ORCID: </strong>
                          <a
                            href="https://orcid.org/register"
                            target="_blank"
                            rel="noreferrer"
                          >
                            orcid.org/register
                          </a>
                        </Typography>
                        <Typography fontSize={"12px"}>(Opcional)</Typography>

                        <TextField
                          autoComplete="off"
                          fullWidth
                          value={objeto?.orcid ?? ""}
                          onChange={(e) =>
                            setObjeto({ ...objeto, orcid: e.target.value })
                          }
                          size="small"
                        />
                      </Grid2>
                    </>
                  )}
                </Grid2>
                <br />
                <Divider />
                <br />
                <Box sx={{ ...centrado, width: "100%" }}>
                  <FormControl>
                    <FormLabel>
                      <strong>Método de Pago</strong>
                    </FormLabel>
                    <RadioGroup
                      orientation="vertical"
                      value={objeto?.pago ?? ""}
                      onChange={(e) =>
                        setObjeto({ ...objeto, pago: e.target.value })
                      }
                    >
                      {/* <Radio
                        value="tarjeta"
                        label="Pago en línea vía PayPhone"
                      /> */}
                      <Radio
                        value="tarjeta"
                        label="Pago tarjeta Débito / Crédito"
                      />
                      <Radio
                        value="transferencia"
                        label="Transferencia Bancaria"
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
                <br />
                {objeto?.pago && (
                  <Alert color="warning">
                    {objeto?.pago === "transferencia" &&
                      `Para pagos por Transferencia, se necesita que envíe el
                  comprobante al correo o WhatsApp, junto con el código de la
                  compra, dentro de los siguientes 15 minutos al generar el
                  pago, caso contrario, no se podrá asegurar su producto.`}

                    {objeto?.pago === "tarjeta" &&
                      `Para pagos con Tarjeta, se generará un botón de pago con una vigencia de 10 minutos, 
                    si no realiza el pago en ese tiempo se cancelará la compra.`}
                  </Alert>
                )}
                <br />
                <Divider />
                <br />
              </Box>
            </DialogContent>
            <DialogActions sx={{ background: "#eeeeee" }}>
              <Box>
                <Typography
                  pr={2}
                  sx={{ color: "text.primary", fontSize: "24px" }}
                >
                  <strong>Total: </strong>$
                  {(
                    parseFloat(getTotalCompra()) - parseFloat(getDescuento())
                  ).toFixed(2)}
                </Typography>
                <Button
                  color="success"
                  sx={{ margin: "5px" }}
                  onClick={() => crearCompra()}
                  disabled={
                    !(objeto?.nombre && objeto?.nombre?.trim()?.length > 0) ||
                    !(
                      objeto?.apellido && objeto?.apellido?.trim()?.length > 0
                    ) ||
                    !(objeto?.cedula && objeto?.cedula?.trim()?.length > 0) ||
                    !(
                      objeto?.nacimiento &&
                      objeto?.nacimiento?.trim()?.length > 0
                    ) ||
                    !(objeto?.celular && objeto?.celular?.trim()?.length > 0) ||
                    !(objeto?.pais && objeto?.pais?.trim()?.length > 0) ||
                    !(objeto?.correo && objeto?.correo?.trim()?.length > 0) ||
                    !(
                      objeto?.profesion && objeto?.profesion?.trim()?.length > 0
                    ) ||
                    !(objeto?.ciudad && objeto?.ciudad?.trim()?.length > 0) ||
                    !(
                      objeto?.ids?.filter((val) => !isNaN(val?.eleccion))
                        .length > 0 &&
                      objeto?.universidad &&
                      objeto?.universidad?.trim()?.length > 0
                    ) ||
                    !(
                      objeto?.ids?.filter((val) => !isNaN(val?.eleccion))
                        .length > 0 &&
                      objeto?.lugar &&
                      objeto?.lugar?.trim()?.length > 0
                    )
                  }
                >
                  PAGAR
                </Button>
                <Button
                  color="danger"
                  sx={{ margin: "5px" }}
                  onClick={() =>
                    setObjeto({
                      carrito: carrito,
                    })
                  }
                >
                  CANCELAR
                </Button>
              </Box>
            </DialogActions>
          </Dialog>
        </>
      )}

      <Dialog
        open={error?.producto?.id?.length > 0}
        maxWidth="md"
        fullWidth
        onClose={() => {
          // setPaypal({});
          // setTimeLeft(0);
          setError(null);
        }}
      >
        <DialogContent>
          <Typography
            sx={{ padding: "20px" }}
            align="justify"
            fontSize={"18px"}
          >
            El producto <strong>{error?.producto?.name ?? ""}</strong>{" "}
            {error?.tipo ?? ""}, se encuentra sin disponibilidad.
          </Typography>
          <Box sx={{ ...centrado }}>
            <img alt="agotado" src={agotado} width={"80%"} />
          </Box>
          <Box sx={{ ...centrado, overflowX: "auto" }}>
            {productos
              ?.filter((val) => {
                if (error?.producto?.especialidades) {
                  for (const el of error.producto.especialidades) {
                    if (val?.especialidades?.includes(el)) {
                      return true;
                    }
                  }
                } else {
                  return false;
                }
              })
              ?.map((val) => (
                <Box key={val?.id} sx={{ padding: "10px", width: "350px" }}>
                  <Paper
                    elevation={2}
                    sx={{
                      ":hover": {
                        boxShadow: 20,
                      },
                      padding: "20px",
                      border: 1,
                      borderRadius: "25px",
                      borderColor: theme2.palette.primary.main,
                    }}
                  >
                    <Stack spacing={2}>
                      <Box
                        sx={{
                          height: "0px",
                          padding: "0px",
                          margin: "0px",
                          textAlign: "right",
                        }}
                      >
                        {val?.descuento === "SI" && (
                          <Chip
                            sx={{ marginBottom: "-40px", marginRight: "5px" }}
                            color="danger"
                            variant="solid"
                          >
                            {" "}
                            Oferta
                          </Chip>
                        )}
                      </Box>
                      <Typography
                        fontWeight={"bold"}
                        sx={{
                          height: "70px",
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          fontSize: "15px",
                          WebkitLineClamp: 3,
                          textOverflow: "ellipsis",
                        }}
                      >
                        {val?.name}
                      </Typography>
                      {val?.especialidades?.length > 0 && (
                        <Box>
                          <strong>Especialidades:</strong>
                          <Typography sx={{ fontSize: "14px" }}>
                            {val?.especialidades?.join(", ")}
                          </Typography>
                        </Box>
                      )}
                      <Box>
                        {val?.descuento === "SI" && (
                          <Chip
                            color="neutral"
                            sx={{ textDecoration: "line-through" }}
                          >
                            {"$ " +
                              parseFloat(val?.precioSinDescuento).toFixed(2)}
                          </Chip>
                        )}
                        <Chip color="success">
                          {"$ " + parseFloat(val?.minimo).toFixed(2)}
                          {val?.minimo !== val?.maximo && (
                            <>{" ~ $ " + parseFloat(val?.maximo).toFixed(2)}</>
                          )}
                        </Chip>
                      </Box>
                      <Button
                        onClick={() => {
                          navigate("/articulo/" + val?.id);
                        }}
                        variant="solid"
                      >
                        <Typography
                          fontWeight={"bold"}
                          sx={{ textAlign: "center" }}
                        >
                          Ver más
                        </Typography>
                      </Button>
                    </Stack>
                  </Paper>
                </Box>
              ))}
          </Box>
        </DialogContent>
      </Dialog>

      {/* <Dialog
        open={paypal?.id?.length > 0}
        maxWidth="sm"
        fullWidth
        style={{ zIndex: 10001 }}
        onClose={() => {
          if (timeLeft === 0) {
            setObjeto({
              carrito: carrito,
            });
            setTimeLeft(0);
            setPaypal({});
            setError(null);
          }
        }}
      >
        <DialogContent>
          <Alert color="warning">
            Tiene 10 minutos para realizar la compra, en caso de no cumplir se
            cerrá el botón de pago y se cancelará la compra
          </Alert>
          <br />

          <Typography>
            <strong>Tiempo Restante: </strong>{" "}
            <Chip>{formatTime(timeLeft)}</Chip>
          </Typography>
          <br />

          <Box sx={{ ...centrado, overflowX: "auto" }}>
            <PayPalProvider
              clientId={process.env.REACT_APP_PAYPAL}
              pageType="checkout"
            >
              <Box sx={{ width: "90%" }}>
                {timeLeft === 0 ? (
                  <Typography style={{ color: "red" }}>
                    ⏰ El tiempo para completar el pago ha expirado.
                  </Typography>
                ) : (
                  <PayPalOneTimePaymentButton
                    createOrder={async () => {
                      const response = await fetch(
                        "https://publimed.net/API/paypalOrder.php",
                        {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                          },
                          body: JSON.stringify({
                            value: "15.00",
                          }),
                        },
                      );
                      const { id } = await response.json();
                      return { orderId: id };
                    }}
                    
                    onApprove={(data) => {
                      // return actions.order.capture().then((payload) => {
                        setPaypal({ ...paypal, cambiando: "SI" });
                        // if (payload?.status === "COMPLETED") {
                          cambiarEstado("APROBADO", paypal?.id, data);
                        // } else {
                        //   cambiarEstado("CANCELADO", paypal?.id);
                        // }
                      // });
                    }}
                    onCancel={(data) =>{
                      setPaypal({ ...paypal, cambiando: "SI" });
                      cambiarEstado("CANCELADO", paypal?.id);
                    }}
                    onError={(data) => {
                      setPaypal({ ...paypal, cambiando: "SI" });
                      cambiarEstado("CANCELADO", paypal?.id);
                    }}
                  />
                  // <PayPalButtons
                  //   style={{
                  //     layout: "vertical",
                  //     color: "gold",
                  //     height: 50,
                  //   }}
                  //   createOrder={(data, actions) => {
                  //     return actions.order.create({
                  //       purchase_units: [
                  //         {
                  //           amount: {
                  //             currency_code: "USD",
                  //             value: paypal?.total,
                  //           },
                  //         },
                  //       ],
                  //       application_context: {
                  //         shipping_preference: "NO_SHIPPING",
                  //       },
                  //     });
                  //   }}
                  //   onApprove={(data, actions) => {
                  //     return actions.order.capture().then((payload) => {
                  //       setPaypal({ ...paypal, cambiando: "SI" });
                  //       if (payload?.status === "COMPLETED") {
                  //         cambiarEstado("APROBADO", paypal?.id, payload);
                  //       } else {
                  //         cambiarEstado("CANCELADO", paypal?.id);
                  //       }
                  //     });
                  //   }}
                  //   onError={(e) => {
                  //     // console.error(e);
                  //     setPaypal({ ...paypal, cambiando: "SI" });
                  //     cambiarEstado("CANCELADO", paypal?.id);
                  //   }}
                  //   onCancel={(e) => {
                  //     // console.error(e);
                  //     setPaypal({ ...paypal, cambiando: "SI" });
                  //     cambiarEstado("CANCELADO", paypal?.id);
                  //   }}
                  // />
                )}
              </Box>
            </PayPalProvider>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            color="danger"
            sx={{ margin: "5px" }}
            onClick={() => cambiarEstado("CANCELADO", paypal?.id)}
          >
            CANCELAR
          </Button>
        </DialogActions>
      </Dialog> */}
    </Box>
  );
};
